export default __webpack_public_path__ + "static/media/age.a0c4e929.svg";